import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './utils/http';
import 'babel-polyfill'
import VueDragResize from 'vue-drag-resize'
import moment from 'moment'

import store from './store/index';

Vue.use(ElementUI);
Vue.prototype.$axios = axios;

Vue.component('vue-drag-resize', VueDragResize);
Vue.prototype.$moment = moment;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  let token = store.getters.token;
  if (!token && (to.path !== '/login' && to.path !== '/forgetpassword' && to.path !== '/resetpassword')) {
    next('/login');
  } else {
    next();
  }
});

const app = new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js